var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.styles,attrs:{"disabled":_vm.disabled,"type":_vm.type}},[_vm._t("default"),_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }